// extracted by mini-css-extract-plugin
export default {"image":"featuredPage-module--image--Ke-56","pageTitle":"featuredPage-module--pageTitle--31be9","pageSummary":"featuredPage-module--pageSummary--2xj0k"};